import { useSeedsAnalytics } from '@/hooks/use-seeds';
import { useAuthContext } from '@/contexts/auth-context';
import { SeedsAnalyticsCards } from '@/components/analytics/seeds-analytics-cards';
import { CategoryStatsTable } from '@/components/analytics/category-stats-table';
import { TopSeedsTable } from '@/components/analytics/top-seeds-table';
import { AIStatsCard } from '@/components/analytics/ai-stats-card';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export default function SeedsAnalyticsPage() {
  const { user } = useAuthContext();
  const { data, isLoading } = useSeedsAnalytics();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="grid gap-4 md:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-24" />
          ))}
        </div>
        <Skeleton className="h-48" />
      </div>
    );
  }

  if (!data) {
    return <p className="text-muted-foreground">No analytics data available.</p>;
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Seeds Analytics</h2>

      <SeedsAnalyticsCards
        totalSeeds={data.total_seeds}
        totalPersonalized={data.total_personalized}
        totalSessions={data.total_sessions}
        overallCompletionRate={data.overall_completion_rate}
      />

      <div className="grid gap-6 lg:grid-cols-2">
        <Card>
          <CardHeader>
            <CardTitle>By Category</CardTitle>
          </CardHeader>
          <CardContent>
            <CategoryStatsTable categories={data.by_category ?? []} />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Top Seeds</CardTitle>
          </CardHeader>
          <CardContent>
            <TopSeedsTable seeds={data.top_seeds ?? []} />
          </CardContent>
        </Card>
      </div>

      {user?.role === 'admin' && data.ai_stats && (
        <AIStatsCard stats={data.ai_stats} />
      )}
    </div>
  );
}
